import { use } from 'react';
import { ColorModeContext, type ColorModeContextValue } from '@/theme/colorModeContext';

export function useColorMode(): ColorModeContextValue {
  const context = use(ColorModeContext);
  if (!context) {
    throw new Error('useColorMode must be used within a ColorModeProvider');
  }
  return context;
}
